import { useEffect } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { COMMAND_PRIORITY_CRITICAL, PASTE_COMMAND } from "lexical"

import { getClipboardImageFiles } from "@/components/lexical/plugins/paste-image/clipboard"

interface CommentAttachmentPastePluginProps {
  onPasteImages: (files: File[]) => void
  disabled?: boolean
}

export function CommentAttachmentPastePlugin({
  onPasteImages,
  disabled = false,
}: CommentAttachmentPastePluginProps): null {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        if (disabled || !(event instanceof ClipboardEvent)) return false

        const imageFiles = getClipboardImageFiles(event.clipboardData)
        if (!imageFiles.length) return false

        event.preventDefault()
        onPasteImages(imageFiles)
        return true
      },
      COMMAND_PRIORITY_CRITICAL
    )
  }, [disabled, editor, onPasteImages])

  return null
}
